<template>
  <div class="man band-card">
    <ball></ball>
    <div class="nav">
      <Nav :title="navTitle" :fixed="true"></Nav>
      <div class="top"></div>
    </div>
    <van-form validate-first>
      <van-field
        v-model="form.certificateNo"
        required
        type="textarea"
        rows="1"
        autosize
        size="large"
        label="证件号码"
        :disabled="namefalg"
        placeholder="请输入证件号码"
        :rules="[
          {
            required: true,
            message: '证件号码格式不正确',
            validator: certificateNoValidator,
          },
        ]"
        
      >    
      <template #button>
    <van-uploader :after-read="afterRead" :before-read="beforeRead" >
  <van-button  type="default" icon="scan"></van-button>
</van-uploader>
  </template>
</van-field>
      <van-field
        v-model="form.clientName"
        required
        size="large"
        label="姓名"
        :disabled="namefalg"
        placeholder="请输入姓名"
        :rules="[{ required: true, message: '姓名不能为空' }]"
      />
      <van-field
        readonly
        required
        clickable
        size="large"
        label="民族"
        :value="pickerValue['nation']"
        placeholder="选择民族"
        @click="showPicker['nation'] = true"
        :rules="[{ required: true, message: '请选择民族' }]"
      />
      <!-- <van-field
        readonly
        required
        clickable
        size="large"
        label="血型"
        :value="pickerValue['bloodType']"
        placeholder="选择血型"
        @click="showPicker['bloodType'] = true"
        :rules="[{ required: true, message: '请选择血型' }]"
      /> -->
      <van-field
        readonly
        required
        clickable
        name="area"
        :value="value"
        label="住址"
        placeholder="选择省/市/区"
        @click="showArea = true"
        :rules="[{ required: true, message: '请选择省/市/县' }]"
      />
      <van-field
        required
        v-model="form['address']"
        size="large"
        label="详细地址"
        placeholder="请输入详细地址"
        :rules="[{ required: true, message: '请输入地址' }]"
      />
      <van-field
        v-model="form.phoneNumber"
        required
        size="large"
        label="手机号码"
        placeholder="请输入手机号码"
        :rules="[
          {
            required: true,
            message: '手机号码格式不正确',
            validator: certificatePhone,
          },
        ]"
      />
      <van-field
        readonly
        required
        clickable
        size="large"
        label="职业类型"
        :value="pickerValue['profession']"
        placeholder="选择职业类型"
        @click="showPicker['profession'] = true"
        :rules="[{ required: true, message: '请选择职业类型' }]"
      />
      <div class="tipstext" @click="relevance()" v-if="!namefalg">已有健康卡，一键快速关联</div>
      <div class="submit" v-if="ishaveID">
        <van-button
          class="bottom_button"
          round
          block
          type="info"
          native-type="submit"
          size="nomal"
          @click="namefalg?createsubmit():submit()"
          >{{btntext}}</van-button
        >
      </div>
    </van-form>
    <div class="empty"></div>
    <van-popup v-model="showPicker['certificateType']" round position="bottom">
      <van-picker
        show-toolbar
        :columns="IdCardList"
        value-key="name"
        @cancel="showPicker['certificateType'] = false"
        @confirm="(value) => onConfirm(value, 'certificateType')"
      />
    </van-popup>
    <van-popup v-model="showPicker['pactId']" round position="bottom">
      <van-picker
        show-toolbar
        :columns="pactIdOBJ"
        value-key="name"
        @cancel="showPicker['pactId'] = false"
        @confirm="(value) => onConfirm(value, 'pactId')"
      />
    </van-popup>

    <van-popup v-model="showPicker['bloodType']" round position="bottom">
      <van-picker
        show-toolbar
        :columns="bloodtypeList"
        value-key="name"
        @cancel="showPicker['bloodType'] = false"
        @confirm="(value) => onConfirm(value, 'bloodType')"
      />
    </van-popup>
    <van-popup v-model="showPicker['birthDay']" round position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="showPicker['birthDay'] = false"
        @confirm="(value) => onConfirm(value, 'birthDay')"
      />
    </van-popup>
    <van-popup v-model="showPicker['profession']" round position="bottom">
      <van-picker
        show-toolbar
        :columns="professionOBJ"
        value-key="name"
        @cancel="showPicker['profession'] = false"
        @confirm="(value) => onConfirm(value, 'profession')"
      />
    </van-popup>
    <van-popup v-model="showPicker['nation']" round position="bottom">
      <van-picker
        show-toolbar
        :columns="nationOBJ"
        value-key="name"
        @cancel="showPicker['nation'] = false"
        @confirm="(value) => onConfirm(value, 'nation')"
      />
    </van-popup>
    <van-popup v-model="showPicker['nationalityName']" round position="bottom">
      <van-picker
        show-toolbar
        :columns="nationalityNameOBJ"
        value-key="name"
        @cancel="showPicker['nationalityName'] = false"
        @confirm="(value) => onConfirm(value, 'nationalityName')"
      />
    </van-popup>
    <van-popup v-model="showArea" position="bottom">
      <van-area
        :area-list="areaList"
        @confirm="onConfirm1"
        @cancel="showArea = false"
      />
    </van-popup>

    <van-popup v-model="showPicker.showbirthplace" position="bottom">
      <van-area
        :area-list="areaList"
        :value="form.certificateNo?form.certificateNo.substring(0, 6):''"
        @confirm="
          (value) =>
            onConfirm2(
              value,
              'showbirthplace',
              'birthProvinceName',
              'birthProvinceId',
              'birthCityName',
              'birthCityId',
              'birthCountyName',
              'birthCountyId'
            )
        "
        @cancel="showPicker.showbirthplace = false"
      />
    </van-popup>
  </div>
</template>
<script>
import setOptions from "@/mixins/setOption";
import Nav from "@/components/nav.vue";
import provinceOBJ from "@/utils/area.js";
// import { Picker,Toast } from 'vant';
import area from "@/utils/area1.js";
import ImageCompressor from '@/common/ImageCompressor';
export default {
  mixins: [setOptions],
  data() {
    return {
      btntext:"注册电子健康卡",
      namefalg:false,
      //电子健康卡跨院绑定注册
      qrCodeText: "",
      healthCardId: "",
      phid:"",
      //
      Verification: true,
      timer: 60, //定义初始时间为60s
      sms: "",
      showareanum: "",
      birthplace: "",
      area: area,
      ispath: null,
      ncode: [],
      nname: [],
      nations: {},
      nationId: "",
      nations1: {},
      nations2: {},
      nationalityIds: "",
      nationalityId: "",
      nationalityName: "",
      nationalityId1: "",
      nationalityName1: "",
      nationalityId2: "",
      nationalityName2: "",
      showArea: false,
      areaList: provinceOBJ,
      province: {},
      navTitle: "电子健康卡",
      ishaveID: true,
      value: "",
      IdCardList: [],
      pactIdOBJ: [],
      professionOBJ: [],
      bloodtypeList: [
        { value: "1", name: "A型" },
        { value: "2", name: "B型" },
        { value: "3", name: "O型" },
        { value: "4", name: "AB型" },
        { value: "5", name: "不详" },
        { value: "6", name: "未查" },
      ],
      nationOBJ: [
        { value: "01", name: "汉族" },
        { value: "02", name: "蒙古族" },
        { value: "03", name: "回族" },
        { value: "04", name: "藏族" },
        { value: "05", name: "维吾尔族" },
        { value: "06", name: "苗族" },
        { value: "07", name: "彝族" },
        { value: "08", name: "壮族" },
        { value: "09", name: "布依族" },
        { value: "10", name: "朝鲜族" },
        { value: "11", name: "满族" },
        { value: "12", name: "侗族" },
        { value: "13", name: "瑶族" },
        { value: "14", name: "白族" },
        { value: "15", name: "土家族" },
        { value: "16", name: "哈尼族" },
        { value: "17", name: "哈萨克族" },
        { value: "18", name: "傣族" },
        { value: "19", name: "黎族" },
        { value: "20", name: "傈僳族" },
        { value: "21", name: "佤族" },
        { value: "22", name: "畲族" },
        { value: "23", name: "高山族" },
        { value: "24", name: "拉祜族" },
        { value: "25", name: "水族" },
        { value: "26", name: "东乡族" },
        { value: "27", name: "纳西族" },
        { value: "28", name: "景颇族" },
        { value: "29", name: "柯尔克孜族" },
        { value: "30", name: "土族" },
        { value: "31", name: "达斡尔族" },
        { value: "32", name: "仫佬族" },
        { value: "33", name: "羌族" },
        { value: "34", name: "布朗族" },
        { value: "35", name: "撒拉族" },
        { value: "36", name: "毛难族" },
        { value: "37", name: "仡佬族" },
        { value: "38", name: "锡伯族" },
        { value: "39", name: "阿昌族" },
        { value: "40", name: "普米族" },
        { value: "41", name: "塔吉克族" },
        { value: "42", name: "怒族" },
        { value: "43", name: "乌孜别克族" },
        { value: "44", name: "俄罗斯族" },
        { value: "45", name: "鄂温克族" },
        { value: "46", name: "崩龙族" },
        { value: "47", name: "保安族" },
        { value: "48", name: "裕固族" },
        { value: "49", name: "京族" },
        { value: "50", name: "塔塔尔族" },
        { value: "51", name: "独龙族" },
        { value: "52", name: "鄂伦春族" },
        { value: "53", name: "赫哲族" },
        { value: "54", name: "门巴族" },
        { value: "55", name: "珞巴族" },
        { value: "56", name: "基诺族" },
      ],
      nationalityNameOBJ: [
        { value: "156", name: "中国" },
        { value: "184", name: "库克群岛" },
        { value: "262", name: "吉布提" },
        { value: "218", name: "厄瓜多尔" },
        { value: "232", name: "厄立特里亚" },
        { value: "234", name: "法罗群岛" },
        { value: "254", name: "法属圭亚那" },
        { value: "598", name: "巴布亚新几内亚" },
        { value: "334", name: "赫德岛和麦克唐纳岛" },
        { value: "400", name: "约旦" },
        { value: "520", name: "瑙鲁" },
        { value: "528", name: "荷兰" },
        { value: "530", name: "荷属安的列斯" },
        { value: "540", name: "新喀里多尼亚" },
        { value: "558", name: "尼加拉瓜" },
        { value: "562", name: "尼日尔" },
        { value: "566", name: "尼日利亚" },
        { value: "574", name: "诺福克岛" },
        { value: "578", name: "挪威" },
        { value: "586", name: "巴基斯坦" },
        { value: "585", name: "帕劳" },
        { value: "275", name: "巴勒斯坦" },
        { value: "446", name: "澳门" },
        { value: "426", name: "莱索托" },
        { value: "466", name: "马里" },
        { value: "500", name: "蒙特塞拉特" },
        { value: "580", name: "北马里亚纳" },
        { value: "270", name: "冈比亚Gambia" },
        { value: "268", name: "格鲁吉亚" },
        { value: "276", name: "德国" },
        { value: "292", name: "直布罗陀" },
        { value: "300", name: "希腊" },
        { value: "304", name: "格陵兰" },
        { value: "316", name: "关岛" },
        { value: "312", name: "瓜德罗普" },
        { value: "12", name: "阿尔及利亚" },
        { value: "458", name: "马来西亚" },
        { value: "584", name: "马绍尔群岛" },
        { value: "175", name: "马约特" },
        { value: "492", name: "摩纳哥" },
        { value: "508", name: "莫桑比克" },
        { value: "162", name: "圣诞岛" },
        { value: "166", name: "科科斯(基林)群岛" },
        { value: "174", name: "科摩罗" },
        { value: "178", name: "刚果(布)" },
        { value: "180", name: "刚果(金)" },
        { value: "480", name: "毛里求斯" },
        { value: "484", name: "墨西哥" },
        { value: "583", name: "密克罗尼西亚联邦" },
        { value: "320", name: "危地马拉" },
        { value: "188", name: "哥斯达黎加" },
        { value: "384", name: "科特迪瓦" },
        { value: "818", name: "埃及" },
        { value: "222", name: "萨尔瓦多" },
        { value: "226", name: "赤道几内亚" },
        { value: "233", name: "爱沙尼亚" },
        { value: "231", name: "埃塞俄比亚" },
        { value: "242", name: "斐济" },
        { value: "246", name: "芬兰" },
        { value: "250", name: "法国" },
        { value: "258", name: "法属波利尼西亚" },
        { value: "260", name: "法属南部领土" },
        { value: "524", name: "尼泊尔" },
        { value: "554", name: "新西兰" },
        { value: "570", name: "纽埃" },
        { value: "512", name: "阿曼" },
        { value: "591", name: "巴拿马" },
        { value: "84", name: "伯利兹" },
        { value: "854", name: "布基纳法索" },
        { value: "158", name: "台湾" },
        { value: "196", name: "塞浦路斯" },
        { value: "238", name: "福克兰群岛(马尔维纳斯)" },
        { value: "646", name: "卢旺达" },
        { value: "654", name: "圣赫勒拿" },
        { value: "659", name: "圣基茨和尼维斯" },
        { value: "666", name: "圣皮埃尔和密克隆" },
        { value: "882", name: "萨摩亚" },
        { value: "498", name: "摩尔多瓦" },
        { value: "496", name: "蒙古" },
        { value: "504", name: "摩洛哥" },
        { value: "104", name: "缅甸" },
        { value: "516", name: "纳米比亚" },
        { value: "620", name: "葡萄牙" },
        { value: "662", name: "圣卢西亚" },
        { value: "690", name: "塞舌尔" },
        { value: "724", name: "西班牙" },
        { value: "780", name: "特立尼达和多巴哥" },
        { value: "548", name: "瓦努阿图" },
        { value: "736", name: "苏丹" },
        { value: "744", name: "斯瓦尔巴群岛" },
        { value: "748", name: "斯威士兰" },
        { value: "752", name: "瑞典" },
        { value: "760", name: "叙利亚" },
        { value: "762", name: "塔吉克斯坦" },
        { value: "834", name: "坦桑尼亚" },
        { value: "674", name: "圣马力诺" },
        { value: "678", name: "圣多美和普林西比" },
        { value: "682", name: "沙特阿拉伯" },
        { value: "694", name: "塞拉利昂" },
        { value: "702", name: "新加坡" },
        { value: "703", name: "斯洛伐克" },
        { value: "705", name: "斯洛文尼亚" },
        { value: "90", name: "所罗门群岛" },
        { value: "706", name: "索马里" },
        { value: "710", name: "南非" },
        { value: "239", name: "南乔治亚岛和南桑德韦奇岛" },
        { value: "144", name: "斯里兰卡" },
        { value: "772", name: "托克劳" },
        { value: "788", name: "突尼斯" },
        { value: "792", name: "土耳其" },
        { value: "31", name: "阿塞拜疆" },
        { value: "600", name: "巴拉圭" },
        { value: "604", name: "秘鲁" },
        { value: "608", name: "菲律宾" },
        { value: "612", name: "皮特凯恩群岛" },
        { value: "616", name: "波兰" },
        { value: "630", name: "波多黎各" },
        { value: "634", name: "卡塔尔" },
        { value: "638", name: "留尼汪" },
        { value: "642", name: "罗马尼亚" },
        { value: "643", name: "俄罗斯联邦" },
        { value: "796", name: "特克斯科斯群岛" },
        { value: "798", name: "图瓦卢" },
        { value: "800", name: "乌干达" },
        { value: "784", name: "阿联酋" },
        { value: "826", name: "英国" },
        { value: "840", name: "美国" },
        { value: "858", name: "乌拉圭" },
        { value: "860", name: "乌兹别克斯坦" },
        { value: "704", name: "越南" },
        { value: "92", name: "英属维尔京群岛" },
        { value: "850", name: "美属维尔京群岛" },
        { value: "732", name: "西撒哈拉" },
        { value: "887", name: "也门" },
        { value: "891", name: "南斯拉夫" },
        { value: "716", name: "津巴布韦" },
        { value: "768", name: "多哥" },
        { value: "152", name: "智利" },
        { value: "344", name: "香港" },
        { value: "686", name: "塞内加尔" },
        { value: "266", name: "加蓬" },
        { value: "288", name: "加纳" },
        { value: "308", name: "格林纳达" },
        { value: "324", name: "几内亚" },
        { value: "36", name: "澳大利亚" },
        { value: "740", name: "苏里南" },
        { value: "756", name: "瑞士" },
        { value: "764", name: "泰国" },
        { value: "776", name: "汤加" },
        { value: "795", name: "土库曼斯坦" },
        { value: "804", name: "乌克兰" },
        { value: "581", name: "美国本土外小岛屿" },
        { value: "862", name: "委内瑞拉" },
        { value: "876", name: "瓦利斯和富图纳" },
        { value: "894", name: "赞比亚" },
        { value: "4", name: "阿富汗" },
        { value: "16", name: "美属萨摩亚" },
        { value: "20", name: "安道尔" },
        { value: "660", name: "安圭拉" },
        { value: "10", name: "南极洲" },
        { value: "28", name: "安提瓜和巴布达" },
        { value: "51", name: "亚美尼亚" },
        { value: "533", name: "阿鲁巴" },
        { value: "44", name: "巴哈马" },
        { value: "48", name: "巴林" },
        { value: "50", name: "孟加拉国" },
        { value: "52", name: "巴巴多斯" },
        { value: "112", name: "白俄罗斯" },
        { value: "56", name: "比利时" },
        { value: "204", name: "贝宁" },
        { value: "60", name: "百慕大" },
        { value: "64", name: "不丹" },
        { value: "68", name: "玻利维亚" },
        { value: "70", name: "波黑" },
        { value: "72", name: "博茨瓦纳" },
        { value: "74", name: "布维岛" },
        { value: "76", name: "巴西" },
        { value: "86", name: "英属印度洋领土" },
        { value: "96", name: "文莱" },
        { value: "100", name: "保加利亚" },
        { value: "108", name: "布隆迪" },
        { value: "116", name: "柬埔寨" },
        { value: "120", name: "喀麦隆" },
        { value: "124", name: "加拿大" },
        { value: "132", name: "佛得角" },
        { value: "136", name: "开曼群岛" },
        { value: "140", name: "中非" },
        { value: "148", name: "乍得" },
        { value: "191", name: "克罗地亚" },
        { value: "192", name: "古巴" },
        { value: "203", name: "捷克" },
        { value: "208", name: "丹麦" },
        { value: "212", name: "多米尼克" },
        { value: "214", name: "多米尼加共和国" },
        { value: "670", name: "圣文森特和格林纳丁斯" },
        { value: "336", name: "梵蒂冈" },
        { value: "626", name: "东帝汶" },
        { value: "624", name: "几内亚比绍" },
        { value: "328", name: "圭亚那" },
        { value: "332", name: "海地" },
        { value: "340", name: "洪都拉斯" },
        { value: "348", name: "匈牙利" },
        { value: "352", name: "冰岛" },
        { value: "356", name: "印度" },
        { value: "360", name: "印度尼西亚" },
        { value: "364", name: "伊朗" },
        { value: "368", name: "伊拉克" },
        { value: "372", name: "爱尔兰" },
        { value: "8", name: "阿尔巴尼亚" },
        { value: "24", name: "安哥拉" },
        { value: "32", name: "阿根廷" },
        { value: "40", name: "奥地利" },
        { value: "376", name: "以色列" },
        { value: "380", name: "意大利" },
        { value: "388", name: "牙买加" },
        { value: "392", name: "日本" },
        { value: "398", name: "哈萨克斯坦" },
        { value: "404", name: "肯尼亚" },
        { value: "296", name: "基里巴斯" },
        { value: "408", name: "朝鲜" },
        { value: "410", name: "韩国" },
        { value: "414", name: "科威特" },
        { value: "417", name: "吉尔吉斯斯坦" },
        { value: "418", name: "老挝" },
        { value: "428", name: "拉脱维亚" },
        { value: "422", name: "黎巴嫩" },
        { value: "430", name: "利比里亚" },
        { value: "434", name: "利比亚" },
        { value: "438", name: "列支敦士登" },
        { value: "440", name: "立陶宛" },
        { value: "442", name: "卢森堡" },
        { value: "807", name: "前南马其顿" },
        { value: "450", name: "马达加斯加" },
        { value: "454", name: "马拉维" },
        { value: "462", name: "马尔代夫" },
        { value: "470", name: "马耳他" },
        { value: "474", name: "马提尼克" },
        { value: "478", name: "毛里塔尼亚" },
      ],
      showPicker: {
        showbirthplace: false,
        certificateType: false,
        pactId: false,
        birthDay: false,
        profession: false,
        nation: false,
        province: false,
        nationalityName: false,
        bloodType: false,
      },
      pickerValue: {
        showbirthplace: "",
        certificateType: "居民身份证",
        pactId: "现金",
        profession: "自由职业者",
        nation: "",
        nationalityName: "中国",
        bloodType: "6",
        nativePlaceId: "",
      },
      form: {
        bloodType: "6",
        nativePlaceId: "",
        clientName: "",
        genderId: "",
        certificateType: "1",
        certificateNo: "",
        birthDay: "",
        address: "",
        pactId: "1",
        phoneNumber: "",
        profession: "51",
        nation: "",
        nationalityName: "中国",
        nationalityId: "156",
        birthProvinceId: "",
        birthProvinceName: "",
        birthCityId: "",
        birthCityName: "",
        birthCountyId: "",
        birthCountyName: "",
        hkProvinceId: "",
        hkProvinceName: "",
        hkCityId: "",
        hkCityName: "",
        hkCountyId: "",
        hkCountyName: "",
        nativePlaceId: "",
        wechatCode: "",
      },
      minDate: new Date(1888, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      userInfo: [],
      certificateNoTypeName: "",
      msgflag: false,
    };
  },
  components: {
    Nav,
  },
  mounted() {

    if (this.$route.query.wechatCode) {
      this.form.wechatCode = this.$route.query.wechatCode;
    }
    if (this.$route.query.qrCodeText && this.$route.query.healthCardId) {
      this.form.clientName = this.$route.query.name;
      this.form.certificateNo = this.$route.query.idNumber;
      this.qrCodeText = this.$route.query.qrCodeText;
      this.healthCardId = this.$route.query.healthCardId;
      this.phid = this.$route.query.phid;
      this.namefalg=true
      this.btntext="建档并绑定"
      this.getBindFormData();                           
    }
    this.getcoulms();
    if (this.$route.query.ispath) {
      this.ispath = this.$route.query.ispath;
    }
  },
  created() {},
  methods: {
    //压缩图片
     async beforeRead(file){
   return   await ImageCompressor(file, 'blob', 0.1); //图片压缩 
  },
  //上传身份证图片
   async afterRead(file){
      let a ={
       imageContent:file.content
     }
    console.log(a)
        let url = "/healthcardcontroller/ocrInfo";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          a,
          (data) => {
            console.log(data)
  //            cardInfo: {
  //   name: '吴朋',
  //   id: '532131199802150710',
  //   gender: '男',
  //   nation: '汉',
  //   birth: '1998/2/15',
  //   address: '云南省昭通市水富县两碗镇两碗村老房社54号',
  //   authority: '',
  //   validDate: ''
  // }
            if(data.status!=200||data.data.data.commonOut.errMsg!="成功"){
              this.$toast.fail("上传失败，请重试或手动填写信息 ")
              return
            }
            let  cardInfo=data.data.data.rsp.cardInfo
              this.form.clientName =cardInfo.name;
              this.form.certificateNo = cardInfo.id;
              this.getaddresinfo(cardInfo.id,cardInfo.address)
        //         this.pickerValue[type] = item.name;
        // this.form[type] = item.value;
        // this.showPicker[type] = false;
              this.pickerValue.nation=`${cardInfo.nation}族`
              let nationvalue=this.findnameByValue(this.pickerValue.nation,this.nationOBJ)
              this.form.nation=nationvalue||"01"
          }
        );
    },
      getaddresinfo(certificateNo,addres){
      //  532131199802150710
      // let addres="云南省昭通市水富县两碗镇两湾村老房社54号"
      // let addres2 ="云南省红河哈尼族彝族自治州个旧市"
     let reg=new RegExp("(.*?省|.*?市|.*?自治区)?(.*?市|.*?县|.*?区|.*?自治州)?(.*?县|.*?区|.*?市)");
     let newaddres =addres.match(reg)
        // addProvinceId, addProvinceName, addCityId,    addCityName, addCountyId, addCountyName,
      this.form.addProvinceId = certificateNo.substring(0, 2) + "0000";
      this.form.addProvinceName=newaddres[1]
      this.form.addCityId =certificateNo.substring(0, 4) + "00";
      this.form.addCityName=newaddres[2]
      this.form.addCountyId = certificateNo.substring(0, 6);
     this.form.addCountyName=newaddres[3]
 
     this.form.address=addres.replace(newaddres[0],"")
     this.value=newaddres[0]
    },
    //根据身份证获得籍贯编号
    getaddressID(idCard) {
      if (!idCard || idCard.length < 6) return "";
      let provinceNo = idCard.substring(0, 2) + "0000";
      let cityNo = idCard.substring(0, 4) + "00";
      let countyNo = idCard.substring(0, 6);
      let provinceName = this.area.province_list[provinceNo];
      // console.log(provinceName)
      let cityName = this.area.city_list[cityNo];
      let countyName = this.area.county_list[countyNo];
      let result = {
        hkProvinceId: provinceNo,
        hkProvinceName: provinceName,
        hkCityId: cityNo,
        hkCityName: cityName,
        hkCountyId: countyNo,
        hkCountyName: countyName,
      };

      return result;
    },
    getaddress_ID(idCard) {
      return idCard.substring(0, 6);
    },
    //根据身份证号获取籍贯
    getaddress(idCard) {
      if (!idCard || idCard.length < 6) return "";
      let provinceNo = idCard.substring(0, 2) + "0000";
      let cityNo = idCard.substring(0, 4) + "00";
      let countyNo = idCard.substring(0, 6);

      let provinceName = this.area.province_list[provinceNo];
      // console.log(provinceName)
      let cityName = this.area.city_list[cityNo];
      let countyName = this.area.county_list[countyNo];

      let result =
        (provinceName ? provinceName : "") +
        "" +
        (cityName ? cityName : "") +
        "" +
        (countyName ? countyName : "");

      return result;
    },
    //nav返回
    onClickLeft() {
      this.$router.go(-1);
    },
    getBindFormData() {
      this.pickerValue.nativePlaceId = this.getaddress(this.form.certificateNo);
      this.form.hkProvinceId = this.getaddressID(
        this.form.certificateNo
      ).hkProvinceId;
      // this.showareanum = this.form.certificateNo.substring(0, 6);
      this.form.hkProvinceName = this.getaddressID(
        this.form.certificateNo
      ).hkProvinceName;
      this.form.hkCityId = this.getaddressID(this.form.certificateNo).hkCityId;
      this.form.hkCityName = this.getaddressID(
        this.form.certificateNo
      ).hkCityName;
      this.form.hkCountyId = this.getaddressID(
        this.form.certificateNo
      ).hkCountyId;
      this.form.hkCountyName = this.getaddressID(
        this.form.certificateNo
      ).hkCountyName;
      this.form.nativePlaceId = this.getaddress_ID(this.form.certificateNo);
      this.form.genderId = this.getgenderIDbyIdCard(this.form.certificateNo);
      this.form.birthDay = this.getBirthdayFromIdCard(this.form.certificateNo);

      ////
      this.form.birthProvinceId = this.getaddressID(
        this.form.certificateNo
      ).hkProvinceId;
      // this.showareanum = this.form.certificateNo.substring(0, 6);
      this.form.birthProvinceName = this.getaddressID(
        this.form.certificateNo
      ).hkProvinceName;
      this.form.birthCityId = this.getaddressID(
        this.form.certificateNo
      ).hkCityId;
      this.form.birthCityName = this.getaddressID(
        this.form.certificateNo
      ).hkCityName;
      this.form.birthCountyId = this.getaddressID(
        this.form.certificateNo
      ).hkCountyId;
      this.form.birthCountyName = this.getaddressID(
        this.form.certificateNo
      ).hkCountyName;
    },
    //获取选项卡列表
    async getcoulms() {
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/hospitalconf/index/getObjType";
        let data = null;
        await this.$axios_request.request_data(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            // console.log(data);

            //证件类型
            this.IdCardList = data.data.idCardObj;
            //医保类型
            this.pactIdOBJ = data.data.pactIdOBJ;
            //职业类型
            this.professionOBJ = data.data.professionOBJ;

            // 民族
            // this.nationOBJ =  data.data.nationOBJ;
            // 省/市/县
            // this.provinceOBJ =  data.data.provinceOBJ;
            // console.log(this.provinceOBJ);
            this.$hideLoad();
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    //通过身份证号获得性别
    getgenderIDbyIdCard(idcard) {
      if (parseInt(idcard.substr(16, 1)) % 2 == 1) {
        //男
        return "1";
      } else {
        //女
        return "2";
      }
    },
    //通过身份证获取生日
    getBirthdayFromIdCard(idCard) {
      var birthday = "";
      if (idCard != null && idCard != "") {
        if (idCard.length == 18) {
          birthday = idCard.substr(6, 8);
        }
        birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
      }
      return birthday;
    },
    //根据对象value拿name
    findValueByname(value, info) {
      // for (let temp in info) {
      //   if (info[temp].value == value) {
      //     return info[temp].name;
      //   }
      // }
      return info.find((info) => info.value === value).name;
    },
     //根据对象name拿value
    findnameByValue(name, info) {
      // for (let temp in info) {
      //   if (info[temp].value == value) {
      //     return info[temp].name;
      //   }
      // }
      return info.find((info) => info.name === name).value;
    },
    // 选中类型
    onConfirm(item, type) {
      if (type === "birthDay") {
        this.form[type] = this.formatDate(item);
        this.showPicker[type] = false;
        return;
      }
      this.pickerValue[type] = item.name;
      this.form[type] = item.value;
      this.showPicker[type] = false;
      if (type === "nation") {
        this.pickerValue[type] = item.name;
        this.form[type] = item.value;
        this.showPicker[type] = false;
        // console.log(this.nationId)
      }
      if (type === "nationalityName") {
        this.pickerValue[type] = item.name;
        this.form[type] = item.name;
        this.nationalityIds = { nationalityId: item.value };
        this.showPicker[type] = false;
      }
    },
    onConfirm2(
      values,
      type,
      Provincename,
      Provinceid,
      Cityname,
      Cityid,
      Countyname,
      Countyid
    ) {
      this.pickerValue[type] = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join("/");
      this.showArea = false;
      this.form[Provinceid] = values[0].code;
      this.form[Provincename] = values[0].name;
      this.form[Cityid] = values[1].code;
      this.form[Cityname] = values[1].name;
      this.form[Countyid] = values[2].code;
      this.form[Countyname] = values[2].name;
      this.showPicker[type] = false;
    },
    // 省市县选择
    onConfirm1(values) {
      this.value = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join("/");
      this.showArea = false;
      values.forEach((item, index) => {
        var ncodes = item.code;
        this.ncode.push(ncodes);
        var nnames = item.name;
        this.nname.push(nnames);
        this.nationalityId = { addProvinceId: this.ncode[0] };
        this.nationalityName = { addProvinceName: this.nname[0] };
        this.nations = Object.assign(this.nationalityId, this.nationalityName);
        this.nationalityId1 = { addCityId: this.ncode[1] };
        this.nationalityName1 = { addCityName: this.nname[1] };
        this.nations1 = Object.assign(
          this.nationalityId1,
          this.nationalityName1
        );
        this.nationalityId2 = { addCountyId: this.ncode[2] };
        this.nationalityName2 = { addCountyName: this.nname[2] };
        this.nations2 = Object.assign(
          this.nationalityId2,
          this.nationalityName2
        );
        // console.log(this.nations);
      });
    },
    // 证件号码校验
    certificateNoValidator(value) {
      if (this.form.certificateType === "1")
        return /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/.test(value);
      return true;
    },
    //手机号验证
    certificatePhone(value) {
      return /^1(3|4|5|6|7|8|9)\d{9}$/.test(value);
    },
    // 提交表单
    async submit() {
      if (!this.form.address) {
        this.$toast.fail("未填写地址");
        return;
      }
      if (!this.form.clientName) {
        this.$toast.fail("未填写姓名");
        return;
      }
      if (!this.form.certificateNo) {
        this.$toast.fail("未填写身份证号");
        return;
      }
      if (!this.form.bloodType) {
        this.$toast.fail("未填写姓名");
        return;
      }
      if (!this.form.phoneNumber) {
        this.$toast.fail("未填写手机号");
        return;
      }
      if (!this.form.nation) {
        this.$toast.fail("未填写民族");
        return;
      }
      if (Object.keys(this.value).length == 0) {
        this.$toast.fail("未选择地址");
        return;
      }
      this.getBindFormData();
      try {
        this.$showLoad();
        //注册
        let zc_url ="/healthcardcontroller/registerHealthCard";
        let zc_data = this.form;
        zc_data.nationname = this.pickerValue["nation"];
        var form_data = Object.assign(
          zc_data,
          this.nations,
          this.nations1,
          this.nations2,
          this.nationalityIds,
          this.nationId
        );
        await this.$axios_request.axios_request_body(
          "nodeserver",
          zc_url,
          "POST",
          form_data,
          (data) => {
            this.$hideLoad();
            if (
              data.status === 200 &&
              Object.keys(data.data.data.rsp).length != 0
            ) {
              //   if (this.ispath == 1 || this.ispath == 2) {
              //     this.$toast.success("注册并绑定成功");
              //     setTimeout(() => {
              //       this.$router.push({
              //         path: "/confirmUser",
              //         query: {
              //           ispath: this.ispath,
              //         },
              //       });
              //     }, 1000);
              //     return;
              //   }
              this.$toast.success("注册并绑定成功");
              setTimeout(() => {
                this.$router.push("/HealthcardList");
              }, 1000);
              // } else {
              //   this.$toast.fail("注册并绑定失败, 请核对信息重试");
            } else {
              this.$toast.fail(data.statusText);
            }
          }
        );
      } catch (error) {
        this.$hideLoad();
        this.$toast.fail("注册并绑定失败, 请核对信息重试");
      }
    },
    async createsubmit(){
      try {
        this.$showLoad();
        //注册
        let zc_url ="/healthcardcontroller/createHealthcard";
        let zc_data = this.form;
        var form_data = Object.assign(
          zc_data,
          this.nations,
          this.nations1,
          this.nations2,
          this.nationalityIds,
          this.nationId
        );
        form_data['qrCodeText']= this.qrCodeText
        form_data['healthcardid']=this.healthCardId
        form_data['phid']=this.phid
        await this.$axios_request.axios_request_body(
          "nodeserver",
          zc_url,
          "POST",
          form_data,
          (data) => {
            this.$hideLoad();
            if (
              data.data.falg == 1
            ) {
              //   if (this.ispath == 1 || this.ispath == 2) {
              //     this.$toast.success("注册并绑定成功");
              //     setTimeout(() => {
              //       this.$router.push({
              //         path: "/confirmUser",
              //         query: {
              //           ispath: this.ispath,
              //         },
              //       });
              //     }, 1000);
              //     return;
              //   }
              this.$toast.success("建档并绑定成功");
              setTimeout(() => {
                this.$router.push("/HealthcardList");
              }, 1000);
              // } else {
              //   this.$toast.fail("注册并绑定失败, 请核对信息重试");
            } else {
              this.$toast.fail("建档失败，请稍后重试");
            }
          }
        );
      } catch (error) {
        this.$hideLoad();
        this.$toast.fail("注册并绑定失败, 请核对信息重试");
      }
    },
    async relevance() {
      try {
        this.$showLoad();
        let data = {
          redirect_uri: `http://account.kmmds.top/HealthcardList`,
        };
        let url = "/healthcardcontroller/getHealthCode";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (data) => {
            this.$hideLoad();
            if (data.status == 200 && data.data.url) {
              window.location.href = data.data.url;
            } else {
              this.$toast.fail("网络出错，稍后重试");
              return;
            }
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    //格式化日期
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
  },
};
</script>
<style lang="scss">
.nav {
  .top {
    height: 6vh;
  }
}
.tipstext {
  font-size: 15px;
  color: #5b8df6;
  width: 90vw;
  margin: 0 auto;
  margin-top: 2vh;
  text-align: center;
}
.band-card {
  .van-cell {
    font-size: 16px;
  }
  .van-cell.van-cell--large {
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .van-field__error-message {
    font-size: 14px;
  }
}
.van-field--disabled .van-field__label {
  color: #646566;
}
// 建档按钮
.submit {
  margin: 0px 0px;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 70px;
  display: flex;
  justify-items: center;
  align-items: center;
  background-color: #ffffff;
  border-top: 1px solid #aaaaaa;
  .bottom_button {
    width: 90%;
    margin: 0px auto;
  }
}
.empty {
  height: 65px;
}
</style>